function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import React, { useContext, useEffect, useState } from "react";
import { ComboBox, SelectSkeleton } from "@carbon/react";
import { i18nContext } from "../../table-context";
import { APP_CONFIG_OPTION, APP_CONFIG_OPTION_FEATURE, APP_CONFIG_OPTION_PROP } from "../../Constants";
var itemToString = function itemToString(item) {
  return item ? item.text : "";
};
export default function ConfigureOptionsSelect(_ref) {
  var collectionProperty = _ref.collectionProperty,
    environmentProperty = _ref.environmentProperty,
    findSelectedItem = _ref.findSelectedItem,
    integrationProperty = _ref.integrationProperty,
    optionsProperty = _ref.optionsProperty,
    updateAppConfigProperty = _ref.updateAppConfigProperty;
  var i18n = useContext(i18nContext);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedItem = _useState4[0],
    setSelectedItem = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  function fetchData() {
    if (!integrationProperty || !integrationProperty || !environmentProperty || !collectionProperty || !environmentProperty.value || !collectionProperty.value) {
      setItems([]);
    } else {
      setIsLoading(true);
      var options = [{
        id: APP_CONFIG_OPTION_PROP,
        text: "Property"
      }, {
        id: APP_CONFIG_OPTION_FEATURE,
        text: "Feature flag"
      }];
      setItems(options);
      setIsLoading(false);
    }
  }
  useEffect(function () {
    fetchData();
  }, [integrationProperty, environmentProperty, collectionProperty]);
  useEffect(function () {
    if (items && optionsProperty && optionsProperty.value) {
      var item = findSelectedItem(optionsProperty, items);
      setSelectedItem(item);
    }
  }, [items, optionsProperty]);
  var handleChange = function handleChange(event) {
    var _event$selectedItem;
    var value = ((_event$selectedItem = event.selectedItem) === null || _event$selectedItem === void 0 ? void 0 : _event$selectedItem.id) || "";
    updateAppConfigProperty(APP_CONFIG_OPTION, value);
  };
  var translateIds = function translateIds(menuId) {
    var translations = {
      "close.menu": i18n.messages.menuClose,
      "open.menu": i18n.messages.menuOpen
    };
    return translations[menuId];
  };
  if (isLoading) {
    return /*#__PURE__*/React.createElement(SelectSkeleton, {
      className: "cds--form-item",
      hideLabel: true
    });
  }
  if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
    return /*#__PURE__*/React.createElement(ComboBox, {
      className: "ocr--property-select-dropdown",
      direction: "bottom",
      id: "property-panel-appconfig-option",
      items: items,
      itemToString: itemToString,
      onChange: handleChange,
      placeholder: i18n.messages.propertyAppConfigOptionsSelect,
      selectedItem: selectedItem,
      titleText: i18n.messages.propertyAppConfigOptionsLabel,
      translateWithId: translateIds
    });
  }
  return null;
}